import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { Col, Row } from "reactstrap";
import Footer from "../../website/home/Footer";
import Header from "../../website/home/Header";
import "./PrivacyPolicy.css";
import FetchServerData from "../../../provider/FetchServerData";
import Quill from "../quill/Quill";
class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuccessAlert: false,
      showFailAlert: false,
      value: 0,
      templateDetails: "",
      errorMessageColor: "#000",
      checkbox: false,
      render: false,
    };
    this.getTemplateDetails();
  }
  nextPage() {
    this.props.history.push("/createAccount");
  }

  printContent() {
    let printContents = document.getElementById(
      "termsConditionSection"
    ).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();

    document.body.innerHTML = originalContents;
    this.setState({ render: true });
    document.location.reload(true);
  }

  scrollToSection(elementID) {
    if (document.getElementById(elementID)) {
      document.getElementById(elementID).scrollIntoView();
    }
  }

  handleClickCheckBox = (e) => {
    if (e.target.checked === "true") {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: false,
      });
    } else {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: true,
      });
    }
  };

  getTemplateDetails() {
    let postObject = {};
    FetchServerData.callPostService("/privacyPolicy/geActive", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let templateDetails = output.data.privacyPolicy.data;
          this.setState({ templateDetails: templateDetails, render: true });
        }
      })
      .catch((error) => {});
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <Header />
          <div id="termsConditionSection" style={{ margin: "2em 4em" }}>
            <Row md={12} style={{ margin: "0.5em" }}>
              <Col style={{ textAlign: "center" }}>
                <span
                  style={{
                    textAlign: "center",
                    color: "#000",
                    fontSize: "large",
                    float: "right",
                  }}
                >
                  <ReactToPrint
                    trigger={() => (
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "x-larger",
                          marginRight: "2em",
                          float: "right",
                        }}
                      >
                        <Tooltip title="Print">
                          <PrintRoundedIcon
                            style={{
                              borderRadius: "25%",
                              background: "#867e7e",
                              color: "white",
                              padding: "3px",
                              fontSize: "x-large",
                              width: "30px",
                              minHeight: "30px",
                            }}
                          />
                        </Tooltip>
                      </span>
                    )}
                    content={() => this.componentRef}
                  />
                </span>
              </Col>
            </Row>
            <div
              style={{
                border: "2px solid lightgray",
                marginTop: " 10px",
                padding: "1em",
              }}
              ref={(el) => (this.componentRef = el)}
            >
              <section
                className="contact"
                style={{ padding: "2em", textAlign: "justify" }}
              >
                <Row style={{ margin: "0em 0.5em" }}>
                  <Col md={12}>
                    <Quill
                      text={this.state.templateDetails}
                      className="templateMessageBox"
                      theme="bubble"
                      readOnly={true}
                    />
                  </Col>
                </Row>
              </section>
              <Row>
                <Col md={12}>
                  <span style={{ float: "right" }}>
                    <a
                      onClick={() =>
                        this.scrollToSection("termsConditionSection")
                      }
                      style={{ textDecoration: "none" }}
                    >
                      <Fab
                        aria-label="add"
                        style={{
                          float: "right",
                          fontSize: "small",
                          height: "15px",
                          width: "35px",
                          background: "#ef6603",
                          cursor: "pointer",
                          color: "white",
                          backgroundImage:
                            "-webkit-linear-gradient(bottom, #843b07 0%, #f7b571 100%);",
                          border: "2px solid #edf0f1",
                        }}
                      >
                        <ArrowUpwardIcon />
                      </Fab>{" "}
                    </a>
                  </span>
                </Col>
              </Row>
            </div>
          </div>
          <Footer />
        </>
      );
    }
  }
}

export default PrivacyPolicy;
